/*
 * @Author: Raeesaa Metkari
 * @Date: 2020-09-09 20:25:24
 * @Last Modified by: Raeesaa Metkari
 * @Last Modified time: 2020-09-23 00:00:01
 */

export enum ReportColumnLabels {
  name = 'Activity / Family / Line',
  nameForClientSummary = 'Activity',
  clientName = 'Client',
  zone = 'Zone',
  country = 'Country',
  zam = 'ZAM',
  clientCode = 'Client Code',
  targetValue = 'Budget (Target)',
  targetValueForWorldwideSummary = 'Target Value',
  targetValueForClientReport = 'Budget',
  targetValueForClientSummary = 'Total Budget',
  inProcessValue = 'Order In Process',
  confirmedValue = 'Order Confirmed',
  validatedValue = 'Order Validated',
  totalValue = 'Total Orders',
  totalValueForSummary = 'Actual Value',
  totalVsTargetValue = 'Total Orders vs. Budget',
  totalVsTargetValuePercent = 'Total Orders vs. Budget %',
  targetValueMix = 'Mix Target Value',
  totalValueMix = 'Mix Actual Value',
  targetQuantity = 'Target QTY',
  inProcessQuantity = 'In Process QTY',
  confirmedQuantity = 'Confirmed QTY',
  validatedQuantity = 'Validated QTY',
  totalQuantity = 'Total QTY',
  totalVsTargetQuantity = 'Total Orders vs. Budget QTY',
  totalVsTargetQuantityPercent = 'Total Orders vs. Budget QTY %',
  targetQuantityMix = 'Mix Target QTY ',
  totalQuantityMix = 'Mix Actual QTY',
  totalOrderProducts = 'NB ACs Buy ',
  totalProducts = 'NB ACs'
}

export enum ReportColumnMapping {
  name = 'name',
  clientName = 'clientName',
  zone = 'zone',
  country = 'country',
  zam = 'salesOfficeDescription',
  clientCode = 'code',
  targetValue = 'kpis.targetValue',
  inProcessValue = 'kpis.inprocessValue',
  confirmedValue = 'kpis.confirmValue',
  validatedValue = 'kpis.validatedValue',
  totalValue = 'kpis.totalValue',
  totalVsTargetValue = 'kpis.totalVsTargetValue',
  totalVsTargetValuePercent = 'kpis.totalVsTargetValuePerc',
  targetValueMix = 'kpis.mixTargetValue',
  totalValueMix = 'kpis.mixActualValue',
  targetQuantity = 'kpis.targetQuantity',
  inProcessQuantity = 'kpis.inprocessQuantity',
  confirmedQuantity = 'kpis.confirmQuantity',
  validatedQuantity = 'kpis.validatedQuantity',
  totalQuantity = 'kpis.totalQuantity',
  totalVsTargetQuantity = 'kpis.totalVsTargetQuantity',
  totalVsTargetQuantityPercent = 'kpis.totalVsTargetQuantityPerc',
  targetQuantityMix = 'kpis.mixTargetQuantity',
  totalQuantityMix = 'kpis.mixActualQuantity',
  totalOrderProducts = 'kpis.nbAcsBuy',
  totalProducts = 'totalProducts',
  clientBudgetValue = 'kpis.clientBudgetValue',
  totalVsClientBudgetValuePercent = 'kpis.totalVsClientBudgetValuePerc',
  totalVsClientBudgetValue = 'kpis.totalVsClientBudgetValue'
}
